export default "__VITE_ASSET__DzPmWj0q__ 640w, __VITE_ASSET__Du0ylRns__ 1024w";